import React, { useState } from 'react';
import styled from 'styled-components';
import { Input, Button } from '@blockstack/ui';
const Container = styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
`;

const encode = (data: any) => {
    return Object.keys(data)
        .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
        .join('&');
};

const FeedbackMessage = styled.div`
    width: max-content;
`;

type Props = {
    onSubmit: () => void;
};

export const Stacking: React.FC<Props> = ({ onSubmit }: Props) => {
    const [feedbackFormSubmitted, setFeedbackFormSubmitted] = useState(false);

    return (
        <Container>
            {feedbackFormSubmitted ? (
                <FeedbackMessage>Your email address was saved!</FeedbackMessage>
            ) : (
                <div>
                    <div>
                        <p>Stacking starts soon. Get an update when it does!</p>
                    </div>
                    <form
                        name="stacking"
                        key={'stacking'}
                        data-netlify="true"
                        data-netlify-honeypot="bot-field"
                        onSubmit={(e: React.FormEvent<HTMLFormElement>) => {
                            e.preventDefault();

                            const formData = {
                                // @ts-ignore
                                email: e.target[0].value,
                            };

                            fetch('/', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                                body: encode({ 'form-name': 'stacking', ...formData }),
                            });
                            setFeedbackFormSubmitted(true);
                        }}
                    >
                        <Input
                            type="email"
                            name="email"
                            pattern="\S+"
                            // @ts-ignore
                            required={true}
                            placeholder="Your email address"
                            style={{ margin: '20px 0' }}
                        />
                        <Button type="submit">Send</Button>
                    </form>
                </div>
            )}
        </Container>
    );
};

export default Stacking;
